import { TYPE_STRING } from './input-types';

export const id = 'addressLine2';
export const apiKey = 'AddressLine2';
export const type = TYPE_STRING;

export const addressLine2 = {
  id,
  apiKey,
  type,
};
